let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("drGhL")).then(() => parcelRequire('4LH4L'));